/* eslint-disable react/jsx-no-bind */
import React, {
  useContext, useEffect, useRef, useState,
} from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { useRouter } from 'next/router';
// import Link from 'next/link';
import Image from 'next/image';
import { Modal } from '@madeeasy/universal-login';
import PropTypes from 'prop-types';
import HorizontalScroll from '../shared/HorizontalScroll';
import NoDataFound from '../shared/NoDataFound';
// import { GET_COURSE_DETAILS } from '../shared/operations/QueryCourseDetails';
import GET_COURSE_DETAILS from '../../gql/queries/get-course-details.gql';
import FAQSection from '../faq/faq-section';
import CoursesFeatures from './course-features';
import CourseVideos from '../course-list/CourseVideo';
import Spinner from '../shared/spinner';
import { ToastContext } from '../../contexts/toast-context-with-provider';
// import PageHeader from '../shared/PageHeader';
// capitalizeFirstLetter
import { clearUserSession, getCurrentOrgName } from '../../utils/helpers';
import ErrorMessage from '../shared/error-fetching';
import CREATE_ORDER from '../../gql/mutations/create-order.gql'; // enroll now Mutation
import SuccessFormPopup from '../profile/forms/SuccessFormPopup';
// import PageDataNotFound from '../shared/PageDataNotFound';
import REQUEST_TO_CALLBACK from '../../gql/mutations/request-to-callback.gql';
import { trackEvent } from '../../utils/analytics';
import { getMetadata } from '../../utils/metaDataTitle';
import MetaHead from '../metaHead';
import { madeeasyAdmissionLink, nextiasAdmissionLink } from '../../utils/constants';
// import CourseDetailCard from './courseDetailCard';
import EventNames from '../../utils/event-name-constants';
import { useUser } from '../../contexts/ssr-user-context';
import { useMiscellaneousData } from '../../contexts/ssr-miscellaneous-context';
import RankHoldersCards from './rank-holders-card';
import BatchlistDetails from './course-batchlist';
// import TestimonialSlider from './testimonial';
import CourseDetailsInfo from './course-details-info';
import TabScrollable from '../shared/tab-scrollable';
import Popup from '../shared/Popup';
import CourseCTA from './course-cta-button';
import TestimonialSection from './testimonial-section';
import defaultImg from '../../../public/assets/webinarSeminarPromoBg.png';
import CopyDeeplink from '../shared/CopyDeeplink';
import RichTextContent, { getPlainTextLength } from '../shared/RichTextContent';

// eslint-disable-next-line react/prop-types
function AboutUs({ courseDetail, isExpanded, toggleText }) {
  return (
    <div className="bg-white rounded-[10px] lg:mb-7 mb-[26px] lg:px-[18px] lg:py-[18px]">
      <div className="py-2 lg:py-0">
        <h2 className="lg:text-lg text-base font-semibold text-black mb-[10px]">About this Course</h2>
        <div className="">
          <RichTextContent
            html={courseDetail?.description}
            className={`text-sm font-[300] leading-6 text-black mb-2 ${isExpanded ? '' : 'lg:line-clamp-none line-clamp-4'}`}
          />
          {getPlainTextLength(courseDetail?.description) > 200 && (
            <span className="text-sm text-[#045692] lg:hidden block text-right" onClick={toggleText}>{isExpanded ? 'Read less...' : 'Read more...'}</span>
          )}
        </div>
      </div>
    </div>
  );
}
function CourseDetail() {
  const [activeTab, setActiveTab] = useState('about');
  const [isScrolling, setIsScrolling] = useState(false);
  const aboutRef = useRef(null);
  const facultyRef = useRef(null);
  const batchesRef = useRef(null);
  const faqRef = useRef(null);
  const democlsRef = useRef(null);
  const refs = {
    about: aboutRef,
    batches: batchesRef,
    faculty: facultyRef,
    democls: democlsRef,
    faq: faqRef,
  };

  // // scrollable tab view
  const [showButton, setShowButton] = useState();
  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  }, []);
  const { showToast } = useContext(ToastContext);
  const { miscellaneousData } = useMiscellaneousData();
  const router = useRouter();
  const { slug, page } = router.query;
  const { user } = useUser();
  // const { remoteConfigData, isLoading } = useContext(RemoteConfigContext);
  const noMsg = 'Course Details data not Available';
  const { loading, error, data } = useQuery(GET_COURSE_DETAILS, {
    ssr: true,
    variables: { slug },
    skip: !slug,
  });
  const courseDetals = data?.getCourseBySlug;
  const batchList = courseDetals?.batches;
  const instructors = courseDetals?.instructors;
  const courseVideoData = courseDetals?.courseVideos;
  const batchPrice = courseDetals?.purchaseOptions;
  const batchListedPrice = batchPrice?.[0]?.priceDetails?.listedPriceDetails;
  const [isExpanded, setIsExpanded] = useState(false);
  const [Amount, setAmount] = useState(batchListedPrice?.listedCost);
  const [indexAmount, setIndex] = useState();
  const [indexPopupIndex, setPopupIndex] = useState();
  // const [toastVisible, setToastVisible] = useState(false);
  const [classHover, setHoverclass] = useState(false);
  const [batchName, setBatchName] = useState();

  const [getBatchId, setBatchId] = useState();
  // eslint-disable-next-line no-unused-vars
  const [createOrder, { error: orderError, loading: orderLoading }] = useMutation(CREATE_ORDER);
  // eslint-disable-next-line no-unused-vars
  const [requestTocallback, { error: requestError, loading: requestLoading }] = useMutation(REQUEST_TO_CALLBACK);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [showBatchPopup, setShowBatchPopup] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [hightlight, setHighlight] = useState(false);
  // const breadCrumb = breadCrumbSlug.replace(/^(\w+\s)/, ''); // remove first world
  const { title } = getMetadata('courseDetails'); // metadataTitle
  const redirectionLink = getCurrentOrgName() === 'madeeasyprime' ? madeeasyAdmissionLink : nextiasAdmissionLink;
  const {
    COURSE_DETAILS_VIEWED, BROCHURE_DOWNLOADED, ENROLL_NOW_CLICKED, REQUEST_CALLBACK_CLICKED, BATCH_SELECTED,
  } = EventNames;
  const orgName = getCurrentOrgName();
  const isMadeeasy = orgName === 'madeeasyprime' || orgName === 'madeeasy';
  const deeplinkBaseurl = isMadeeasy ? process.env.NEXT_PUBLIC_DEEPLINK_BASE_URL_MADEEASYPRIME : process.env.NEXT_PUBLIC_DEEPLINK_BASE_URL_NEXTIAS;
  // download pdf
  const handleDownload = (pdfLink) => {
    trackEvent(BROCHURE_DOWNLOADED, {
      courseId: courseDetals?.id,
      courseName: courseDetals?.name,
      batchType: courseDetals?.type,
      screenName: page === 'home' ? 'Home' : 'Library',
    });
    const link = document.createElement('a');
    link.href = pdfLink;
    link.target = '_blank';
    link.download = pdfLink;
    link.click();
  };
  // login popup
  const [showLogin, setShowLogin] = useState(false);
  function toggleModal() {
    setShowLogin(false);
  }
  const productStatus = courseDetals?.purchaseOptions; // key check for batch is product available or not
  const hasActivePurchaseOption = productStatus?.some((opt) => opt?.isPurchaseAllowed) ?? false;
  const displayAmount = hasActivePurchaseOption ? (Amount || batchListedPrice?.listedCost) : null;
  // console.log('productStatus?.length', courseDetals);
  const tabs = [
    { id: 'about', label: 'About' },
    { id: 'batches', label: courseDetals?.batches?.length > 0 ? 'Batches' : '' },
    (courseDetals?.rankholders?.length || courseDetals?.testimonials?.length) && {
      id: 'faculty',
      label: courseDetals?.rankholders?.length
        ? 'Faculty & Achievers'
        : 'Faculty & Testimonials',
    },
    { id: 'democls', label: courseDetals?.courseVideos?.length > 0 ? 'Demo Class' : '' },
    { id: 'faq', label: courseDetals?.faqs?.length ? 'FAQs' : '' },
  ].filter((tab) => tab?.label);

  const handleRequestCall = async () => {
    if (user?.id) {
      if (!batchName && batchList?.length > 1) {
        setShowBatchPopup(true);
      } else {
        trackEvent(REQUEST_CALLBACK_CLICKED, {
          batchId: getBatchId,
          batchName,
          courseId: courseDetals?.id,
          courseName: courseDetals?.name,
          courseType: courseDetals?.type,
          screenName: page === 'home' ? 'Home' : 'Library',
        });
        // if (getBatchId) {
        setShowBatchPopup(false);
        try {
          const response = await requestTocallback({
            variables: {
              courseId: courseDetals?.id,
              batchId: getBatchId,
              productId: courseDetals?.purchaseOptions[indexAmount || 0]?.id,
            },
          });
          if (response?.data?.requestCallback) {
            setPopupOpen(true);
          } else {
            setPopupOpen(false);
          }
          console.log('requestTocallback:', response);
        } catch (err) {
          console.error('Error request to callback:', err);
        }

        // } else {
        //   showToast('Please select a batch to proceed');
        // }
      }
    } else {
      setShowBatchPopup(false);
      setShowLogin(true);
    }
  };

  useEffect(() => {
    if (courseDetals) {
      trackEvent(COURSE_DETAILS_VIEWED, {
        courseId: courseDetals?.id,
        courseName: courseDetals?.name,
        batchType: courseDetals?.type,
        courseDuration: courseDetals?.duration,
        screenName: page === 'home' ? 'Home' : 'Library',
      });
    }
    // eslint-disable-next-line
  }, [courseDetals, page]);

  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };

  const selectAmount = (amount, index, batchId, selBatchName) => {
    console.log('amount', amount, index, batchId, selBatchName);
    // if (productStatus?.length > 0) {
    if (index === indexAmount || index === indexPopupIndex) {
      setAmount('');
      setBatchName('');
      setIndex(null);
      setPopupIndex(null);
      setHoverclass(true);
      setTimeout(() => {
        setHoverclass(false);
      }, 2000);
    } else {
      // setToastVisible(false);
      setAmount(amount);
      setBatchName(selBatchName);
      if (showBatchPopup) {
        setPopupIndex(index);
      } else {
        setIndex(index);
        showToast('You have successfully selected the batch');
      }

      setHoverclass(false);
      setBatchId(batchId);

      trackEvent(BATCH_SELECTED, {
        courseId: courseDetals?.id,
        courseName: courseDetals?.name,
        courseType: courseDetals?.type,
        screenName: page === 'home' ? 'Home' : 'Library',
        batchName,
        batchId: getBatchId,
      });
    }
    // }

    // console.log(amount);
  };
  const redirect = encodeURIComponent(`${`https://${miscellaneousData?.hostname}/prep/courses-combo?courseId=${courseDetals?.id}&batchId=${getBatchId}`}`);

  const [isSticky, setIsSticky] = useState(false);

  const handleClick = async () => {
    if ((!Amount || !batchName) && batchList?.length > 0 && !showBatchPopup) {
      setShowBatchPopup(true);
      return;
    }

    setShowBatchPopup(false);
    // eslint-disable-next-line no-lonely-if
    if (productStatus?.length === 1) {
      if (!user?.id) {
        setShowBatchPopup(false);
        setShowLogin(true);
        return;
      }

      setShowLogin(false);
      if (!batchPrice?.[0]?.isPurchaseAllowed) {
        handleRequestCall();
        return;
      }

      trackEvent(ENROLL_NOW_CLICKED, {
        courseId: courseDetals?.id,
        courseName: courseDetals?.name,
        courseType: courseDetals?.type,
        screenName: page === 'home' ? 'Home' : 'Library',
        batchName,
        batchId: getBatchId,
      });

      try {
        const response = await createOrder({
          variables: {
            productId: courseDetals?.purchaseOptions[0]?.id,
            courseId: courseDetals?.id,
            batchId: getBatchId,
          },
        });
        const paymentLink = response?.data?.createOrder?.paymentLink;
        if (paymentLink) {
          window.open(paymentLink, '_blank');
        }

        console.log('Order created:', response.data);
      } catch (err) {
        console.error('Error creating order:', err);
      }

      return;
    }

    if (getBatchId) {
      router.push(`/courses-combo?courseId=${courseDetals?.id}&batchId=${getBatchId}&redirectTo=${redirect}`);
      return;
    }

    router.push(`/courses-combo?courseId=${courseDetals?.id}&redirectTo=${redirect}`);
  };
  const closeBatchPopup = () => {
    setShowBatchPopup(false);
    setPopupIndex(null);
    setAmount('');
    setBatchName('');
    setIndex(null);
    setPopupIndex(null);
    setHoverclass(true);
    setTimeout(() => {
      setHoverclass(false);
    }, 2000);
  };

  if (loading) return <div><Spinner fullPage /></div>;

  // if (error) return <ErrorMessage error={error.message} fullPage />;
  if (error) {
    const statusCode = error?.networkError?.statusCode || error?.networkError?.response?.status;
    if (statusCode === 401) {
      clearUserSession();
      return null;
    }
    return <ErrorMessage error={error.message} fullPage />;
  }
  return (
    <>
      <MetaHead title={`${courseDetals?.name} ${title}`} />

      <div className="w-full mx-auto text-greyFont scroll-smooth scroll-mb-32 -mb-20">
        <CopyDeeplink link={`${deeplinkBaseurl}/course-details/${courseDetals?.id}`} />
        {courseDetals ? (
          <>

            <div className="container mx-auto">
              <div className="">

                <div className={`${isSticky ? 'lg:sticky navtest lg:top-9 lg:z-10 transform translate-z-0 ' : 'lg:mb-7 mb-[26px]'} lg:px-[17px] lg:pt-[17px] pt-4 px-4`}>
                  <div className={`${!isSticky ? 'bg-white border-0 lg:border border-[#00000014]' : 'lg:bg-[#f9fafb]'} lg:p-3.5 rounded-md`}>
                    {courseDetals ? (
                      <CourseDetailsInfo
                        courseDetail={courseDetals}
                        isExpanded={isExpanded}
                        isScrolledPast={isSticky}
                        toggleText={toggleText}
                        btnText="Download Brochure"
                        setShowBatchPopup={setShowBatchPopup}
                        btnDesktopClass="flex text-xs font-normal text-black items-center"
                        btnMobileClass="flex text-sm text-xs font-normal text-black hidden items-center"
                        handleClick={() => handleDownload(courseDetals?.brochure)}
                        bacthCtaCLick={handleClick}
                        handleRequestCall={handleRequestCall}
                        Amount={displayAmount}
                        selectAmount={selectAmount}
                        batchListedPrice={batchListedPrice}
                        batchList={batchList}
                        productStatus={productStatus}
                        batchPrice={batchPrice}
                      />
                    ) : (
                      <NoDataFound noMsg={noMsg} />

                    )}
                  </div>
                </div>

                {/* Sticky Header */}
                <div className="lg:px-[17px] px-0">
                  <div className={`${isSticky ? 'lg:bg-[#f9fafb] bg-white' : 'lg:bg-[#f9fafb]'} tab-bar-sticky sticky lg:top-[140px] top-14  lg:bg-[#f9fafb] z-10 border-b border-[#D9D9D9] mb-5`}>
                    <div className="mx-auto">
                      <HorizontalScroll className="scrollbar-hide">
                        <TabScrollable setIsSticky={setIsSticky} tabs={tabs} refs={refs} activeTab={activeTab} setActiveTab={setActiveTab} isScrolling={isScrolling} setIsScrolling={setIsScrolling} showButton={showButton} setShowButton={setShowButton} />
                      </HorizontalScroll>
                    </div>
                  </div>
                  {/* about us section */}
                  <div className="lg:mb-7 mb-[26px] lg:px-0 px-4" ref={aboutRef} id="about">
                    <AboutUs courseDetail={courseDetals} isExpanded={isExpanded} toggleText={toggleText} />
                    <div className="lg:mt-7">
                      {courseDetals?.entityFeatures.length > 0 && <CoursesFeatures heading="What You’ll Get" pageName="courseDetail" borderCourse="border-0 lg:mt-[18px] lg:shadow-none shadow-[0_4px_15px_0_#00000012]" courseFeatures={courseDetals?.entityFeatures} />}
                    </div>
                  </div>
                  {/* batch details start */}
                  <div className="px-4 lg:px-0" ref={batchesRef} id="batches">
                    <BatchlistDetails Amount={displayAmount} bgHighlight={hightlight} courseDetals={courseDetals} selectAmount={selectAmount} indexAmount={indexAmount} batchListedPrice={batchListedPrice} batchList={batchList} classHover={classHover} />
                  </div>

                  {/* ----Educator section---- */}
                  <div ref={facultyRef} id="faculty" className="lg:mb-7 mb-[26px] px-4 lg:px-0">
                    {instructors.length > 0
                      && (
                        <div className="lg:mb-7 mb-[26px]">
                          <div className="lg:text-lg text-black text-base font-semibold lg:mb-[18px] mb-4 capitalize">Meet Your Faculty</div>
                          <HorizontalScroll className="scrollbar-hide">
                            <ul className="flex gap-4">
                              {instructors && instructors.length > 0
                                && instructors.map((eduList, index) => (
                                  <li className={`lg:w-[374px] w-full 2xl:w-[504px] flex-none  relative ${instructors.length - 1 === index ? '' : ''}`}>
                                    <Image
                                      width={276}
                                      height={155}
                                      src={eduList?.bannerImage || defaultImg}
                                      onError={(e) => { e.currentTarget.src = '/default-feature.png'; }}
                                      alt="teacher-banner"
                                      className="self-start w-full h-full aspect-[2/1] object-cover rounded-lg"
                                    />
                                  </li>
                                ))}

                            </ul>
                          </HorizontalScroll>
                        </div>
                      )}
                    {/*  Rank holder and testimonial section */}

                    {
                      !(courseDetals?.rankholders?.length === 0 && courseDetals?.testimonials?.length === 0) && (
                        <div className="mt-7">
                          {
                            courseDetals?.rankholders?.length > 0 ? (
                              <HorizontalScroll className="scrollbar-hide">
                                <RankHoldersCards rankerData={courseDetals?.rankholders} secName="Rankholders from This Course" />
                              </HorizontalScroll>
                            ) : (
                              <div className="mt-7">
                                <TestimonialSection heading="Hear From Our Students" pageName="courseDetail" testimonials={courseDetals?.testimonials} />
                              </div>
                            )
                          }
                        </div>
                      )
                    }
                  </div>
                  {/* </HorizontalScroll> */}
                  {/* ----course video---- */}

                  {courseVideoData.length > 0
                    && (
                      <div className="lg:mb-7 mb-[26px] px-4 lg:px-0" id="democls" ref={democlsRef}>
                        <CourseVideos pageName="courseDetail" courseVideoData={courseVideoData} courseDetails={courseDetals} />
                      </div>
                    )}

                  {/* // faq seection */}
                  {courseDetals?.faqs.length > 0
                    && (
                      <div className="" id="faq" ref={faqRef}>
                        <FAQSection borderRemove="border-0 lg:border-0 border-b border-[#E4E4E4] lg:rounded-md rounded-none" pageName="courseDetail" faqDataList={courseDetals?.faqs} />
                      </div>
                    )}
                </div>
                <div className="lg:pb-8 pb-[120px]" />
                {/* {
                  showButton && ( */}
                <div className={`fixed bottom-[61px] right-0 w-full bg-white border-t  z-20 transition-all duration-300  ${showButton ? 'opacity-100 lg:bottom-0 animate-bottomIn' : 'opacity-0 animate-bottomOut'}`}>
                  <div className="container mx-auto px-4">
                    <CourseCTA handleClick={handleClick} handleRequestCall={handleRequestCall} cusWidth="max-w-96" Amount={displayAmount || Amount} batchName={batchName} productStatus={productStatus} batchPrice={batchPrice} />
                  </div>
                </div>
                {/* )
                } */}
              </div>
            </div>
            {/* Our academic counsellors will contact you in some time. */}
            {isPopupOpen && (
              <SuccessFormPopup
                isOpen={isPopupOpen}
                onClose={() => setPopupOpen(false)}
                title="Thank you!"
                isPageNotRedirect
                message="Our experts will get in touch with you shortly."
                type="3"
                pageType="requestCallback"
                redirectionText="Don't Wait!, Click here to start your admission process !"
                redirectionLink={redirectionLink}
              />
            )}
          </>
        ) : (
          <NoDataFound noMsg={noMsg} />
        )}
        {showLogin ? <Modal toggleModal={toggleModal} text="Login" /> : null}

        <Popup
          showPopup={showBatchPopup}
          messageData={<BatchlistDetails showBatchPopup={showBatchPopup} handleClick={handleClick} handleRequestCall={handleRequestCall} batchName={batchName} productStatus={productStatus} batchPrice={batchPrice} Amount={displayAmount} bgHighlight={hightlight} courseDetals={courseDetals} selectAmount={selectAmount} indexAmount={indexPopupIndex} batchListedPrice={batchListedPrice} batchList={batchList} classHover={classHover} />}
          popupFor="MyCourse"
          onPopupClose={() => closeBatchPopup()}
          batchHeading="You missed selecting a batch"
          subHeading="Choose a batch that suits you"
          divwidth="!max-w-[63%] lg:w-auto w-full"
        />
      </div>

    </>
  );
}

AboutUs.propTypes = {
  courseDetail: PropTypes.any,
  isExpanded: PropTypes.any,
  toggleText: PropTypes.any,
};
export default CourseDetail;
